import type { components as BackendComponents } from "@/lib/api/generated/backend";

/**
 * Environment feature flags (BE #898).
 *
 * The backend sends `features` on the current-user payload (`/users/me`,
 * login, refresh). A missing field (older backend, user still loading) means
 * the feature is off: hiding is the safe default.
 *
 * Aliased from the generated OpenAPI schema so a renamed or removed flag
 * breaks the build instead of silently reading as "off".
 * `compliance`: Policies (BE #864). Off in PROD, on in DEV.
 */
export type FeatureFlags = BackendComponents["schemas"]["FeatureFlags"];

export const isComplianceEnabled = (
  user: { features?: FeatureFlags | null } | null | undefined
): boolean => user?.features?.compliance === true;
